<template>
    <section id="home">
        <header class="valign-wrapper">
            <div class="call-to-action center">
                <h3>About Us</h3>
            </div>
        </header>
    </section>
</template>

<script>
    export default {
        name: 'Header'
    }
</script>

<style scoped>
    header {
        height: 70vh;
        width: 100%;
        background: url("/assets/images/header.jpg");
        margin-top: -108px;
        position: relative;
        min-height: 500px;
    }
    
    .call-to-action {
        width: 100%;
    }
</style>